module.exports = __webpack_public_path__ + "img/wenyufuwu.1ce5f311.png";